<template>
  <div>
    <div class="d-flex pt-5 pb-2 mb-3">
      <h2><span>Release notes</span></h2>
    </div>
    <div class="col">
      <div v-if="loadingChangelog">
        <icon name="settings" class="feather-spin"></icon>
      </div>
      <vue-markdown v-else>{{changeLog}}</vue-markdown>
    </div>
  </div>
</template>

<script>
import home from '../../api/home'
import VueMarkdown from 'vue-markdown'

export default {
  data () {
    return {
      changeLog: null,
      loadingChangelog: true
    }
  },
  mounted () {
    home.getChangeLog(
      response => {
        this.changeLog = response
        this.loadingChangelog = false
      },
      error => {
        this.loadingChangelog = false
        console.log('Changelog error', error)
      })
  },
  components: {
    VueMarkdown
  },
  computed: {

  },
  methods: {

  }
}
</script>



// WEBPACK FOOTER //
// src/components/home/ChangeLog.vue